import React from 'react';
import {useForm, FormProvider} from 'react-hook-form';
import {Row} from 'react-bootstrap';

import {getLanguage, t} from 'react-switch-lang';

import InputText from '../../../../components/FormFields/InputText';
import InputDate from '../../../../components/FormFields/inputDate/InputDate';

import {Col} from 'reactstrap';
import SelectList from '../../../../components/select/SelectList';
import {FINDING_STATUS, RISK_LEVEL} from '../../const';
import SelectInfinite from '../../../../components/FormFields/SelectInfinite';
import {appModules} from '../../../../utils/const';

const FindingsFilter = ({submit}) => {
  const lang = getLanguage();
  const methods = useForm({});
  const {handleSubmit, watch} = methods;
  const validFrom = watch('issuedAtFrom');
  const validTo = watch('issuedAtTo');

  return (
    <>
      <FormProvider {...methods}>
        <form
          className={'revisionFilterFormContainer'}
          onSubmit={handleSubmit(submit)}
        >
          <Row className="main-container pt-5 m-0 pb-5">
            <Col>
              <div style={{display: 'flex', gap: '20px', flexWrap: 'wrap'}}>
                <div style={{minWidth: '200px', maxWidth: '200px'}}>
                  <InputText
                    type="text"
                    name="searchInput"
                    placeholder={t('revisions.placeholder.findingName')}
                  />
                </div>
                <div style={{maxWidth: '200px', minWidth: '200px'}}>
                  <SelectList
                    name="riskLevel"
                    className="select"
                    placeholder={t('revisions.placeholder.riskLevel')}
                    options={
                      getLanguage() === 'eng'
                        ? [
                            {
                              label: RISK_LEVEL.LOW.en,
                              value: RISK_LEVEL.LOW.value,
                            },
                            {
                              label: RISK_LEVEL.MEDIUM.en,
                              value: RISK_LEVEL.MEDIUM.value,
                            },
                            {
                              label: RISK_LEVEL.HIGH.en,
                              value: RISK_LEVEL.HIGH.value,
                            },
                          {
                            label: RISK_LEVEL.VERY_HIGH.en,
                            value: RISK_LEVEL.VERY_HIGH.value,
                          }
                          ]
                        : [
                            {
                              label: RISK_LEVEL.LOW.mne,
                              value: RISK_LEVEL.LOW.value,
                            },
                            {
                              label: RISK_LEVEL.MEDIUM.mne,
                              value: RISK_LEVEL.MEDIUM.value,
                            },
                            {
                              label: RISK_LEVEL.HIGH.mne,
                              value: RISK_LEVEL.HIGH.value,
                            },
                          {
                            label: RISK_LEVEL.VERY_HIGH.mne,
                            value: RISK_LEVEL.VERY_HIGH.value,
                          }
                          ]
                    }
                    isClearable
                  />
                </div>
                <div style={{maxWidth: '200px', minWidth: '200px'}}>
                  <SelectList
                    name="findingStatus"
                    className="select"
                    placeholder={t('revisions.placeholder.findingStatus')}
                    options={
                      getLanguage() === 'eng'
                        ? [
                            {
                              label: FINDING_STATUS.COMPLETED.en,
                              value: FINDING_STATUS.COMPLETED.value,
                            },
                            {
                              label: FINDING_STATUS.INCOMPLETE.en,
                              value: FINDING_STATUS.INCOMPLETE.value,
                            },
                            {
                              label: FINDING_STATUS.PARTIALLY_COMPLETED.en,
                              value: FINDING_STATUS.PARTIALLY_COMPLETED.value,
                            },
                            {
                              label: FINDING_STATUS.CONTINUOUS.en,
                              value: FINDING_STATUS.CONTINUOUS.value,
                            },
                            {
                              label: FINDING_STATUS.IN_PROGRESS.en,
                              value: FINDING_STATUS.IN_PROGRESS.value,
                            },
                            {
                              label: FINDING_STATUS.ABORTED.en,
                              value: FINDING_STATUS.ABORTED.value,
                            },
                          ]
                        : [
                            {
                              label: FINDING_STATUS.COMPLETED.mne,
                              value: FINDING_STATUS.COMPLETED.value,
                            },
                            {
                              label: FINDING_STATUS.INCOMPLETE.mne,
                              value: FINDING_STATUS.INCOMPLETE.value,
                            },
                            {
                              label: FINDING_STATUS.PARTIALLY_COMPLETED.mne,
                              value: FINDING_STATUS.PARTIALLY_COMPLETED.value,
                            },
                            {
                              label: FINDING_STATUS.CONTINUOUS.mne,
                              value: FINDING_STATUS.CONTINUOUS.value,
                            },
                            {
                              label: FINDING_STATUS.IN_PROGRESS.mne,
                              value: FINDING_STATUS.IN_PROGRESS.value,
                            },
                            {
                              label: FINDING_STATUS.ABORTED.mne,
                              value: FINDING_STATUS.ABORTED.value,
                            },
                          ]
                    }
                    isClearable
                  />
                </div>
                <div style={{maxWidth: '200px', minWidth: '200px'}}>
                  <SelectInfinite
                    api={`/departments?appModuleId.equals=${appModules?.revisionModule}&active.equals=true`}
                    name="department"
                    labelKey={lang === 'mne' ? 'name' : 'nameEn'}
                    className="department"
                    placeholder={t('risk-cosideration.search.organizedUnit')}
                    isMulti={true}
                  />
                </div>
              </div>
            </Col>

            <div
              style={{maxWidth: '200px', minWidth: '200px'}}
              className="wrapper__right"
            >
              <button
                className="float-right search-button primary-btn"
                disabled={false}
                type="submit"
              >
                {t('risk-cosideration.search.searchButton')}
              </button>
            </div>
          </Row>
        </form>
      </FormProvider>
    </>
  );
};
export default FindingsFilter;
